import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { SkypadUpdateEditionsMutation } from '@/graphql/generated/graphql';

const skypadPolicyEditions: UpdatesConfig['Mutation'] = {
  skypadUpdateEditions: (query: SkypadUpdateEditionsMutation, __: Variables, cache: Cache) => {
    if (query.skypadUpdateEditions) {
      invalidateQuery('skypadPolicyEditions', cache);
    }
  },
};

export default skypadPolicyEditions;
